export default __webpack_public_path__ + "a5307f4135745c175e5b0d12786ea0de.png";